import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/dodao-ui/dodao-ui/academy-ui/src/components/byteCollection/View/ViewByteModal.tsx");
